/**
 * Keyframes for the feedback animations (Progress Bar Indeterminate runner,
 * Skeleton shimmer, Toast timer). Rendered as a React 19 hoisted stylesheet: every
 * component that needs them renders `<FeedbackKeyframes />`, React dedupes it
 * by `href` and puts one copy in <head> - on the server too - so the apps need
 * no CSS of their own. Used through Tailwind arbitrary animations, e.g.
 * `motion-safe:animate-[rp-progress-runner_1.4s_ease-in-out_infinite]`.
 */
const CSS = [
  // A 35% runner from fully off the left edge to fully off the right edge
  // (100% / 35% = 285.7% of its own width).
  '@keyframes rp-progress-runner{from{transform:translateX(-100%)}to{transform:translateX(285.72%)}}',
  // Reduced-motion stand-in: the runner stays put and its opacity pulses.
  '@keyframes rp-progress-pulse{0%,100%{opacity:1}50%{opacity:.4}}',
  // Skeleton highlight (60% of the bone) sweeping from off the left edge to
  // off the right edge (100% / 60% = 166.7% of its own width).
  '@keyframes rp-skeleton-shimmer{from{transform:translateX(-100%)}to{transform:translateX(166.67%)}}',
  // Toast Timer: the countdown bar empties towards the left.
  '@keyframes rp-toast-timer{from{transform:scaleX(1)}to{transform:scaleX(0)}}',
].join('');

export function FeedbackKeyframes() {
  return (
    <style href="reelplicate-ui-feedback-keyframes" precedence="default">
      {CSS}
    </style>
  );
}
